const useBackend = () => {
  const config = useRuntimeConfig()
  let baseUrl = `https://${useHost()}/backend/`
  if (import.meta.server) {
    baseUrl = getBackendBaseUrlForServerSideUsage()
  }

  function getBackendBaseUrlForServerSideUsage (): string {
    if (config.public.nuxtEnvironmentStage === 'PRODUCTION') {
      return 'https://backend.travanto.de/backend/'
    }
    if (config.public.nuxtEnvironmentStage === 'STAGING') {
      return 'https://backend-staging.travanto.de/backend/'
    }
    return 'http://portal-backend/backend/' // 'LOCAL', 'TEST'
  }

  const apiUrl = baseUrl + 'api/'
  const formsUrl = baseUrl + 'forms/'
  const servicesUrl = baseUrl + 'services/'

  return {
    baseUrl,
    apiUrl,
    formsUrl,
    servicesUrl
  }
}

// export { useBackend }
export default useBackend
